import * as React from 'react';

interface Polygon1SvgProps {
  stroke?: string;
  style?: React.CSSProperties;
}

export function Polygon1Svg(props: Polygon1SvgProps) {
  const {
    stroke = '#17171A',
    style = {
      position: 'absolute',
      right: -7,
      top: 0,
    },
  } = props;

  return (
    <svg
      width='12'
      height='9'
      viewBox='0 0 12 9'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
    >
      <path
        d='M3.65704 6.80375L2.12726 7.65362L2.97714 6.12385L6.51267 -0.240115L6.83458 -0.819564L7.3033 -0.350847L10.1317 2.47758L10.6004 2.9463L10.021 3.26821L3.65704 6.80375Z'
        fill='#FAF65C'
        stroke={stroke}
      />
    </svg>
  );
}
